module.exports = __webpack_public_path__ + "static/FrolicLogo-1ks-fe1e106bbb6ea075e5cd226b35ed7276.png";